<template>
    <v-app-bar class="app-header" app fixed clipped-left>
        <v-layout align-center justify-space-between row>
            <span class="app-name" :class="{mobile: this.$ut.isMobile()}">
                <img
                    src="@/assets/img/fpt_logo_2.svg"
                    alt="avatar"
                    @click="redirectTo('/')"
                    class="logo"
                    v-if="!this.$ut.isMobile()"
                >
            </span>
            <BotSelector></BotSelector>
            <v-spacer></v-spacer>
            <LanguageSelector class="mr-5"></LanguageSelector>
            <UserMenu></UserMenu>
        </v-layout>
    </v-app-bar>
</template>
<script>
import UserMenu from '../modules/fptai/components/UserMenu.vue'
import LanguageSelector from '@/modules/fptai/components/LanguageSelector'
import BotSelector from '@/components/BotSelector'

export default {
    name: 'AppToolbar',
    components: {
        BotSelector,
        LanguageSelector,
        UserMenu
    },
    data () {
        return {
            systemName: process.env.VUE_APP_SYSTEM_NAME
        }
    },
    created () {
        if (this.$store.getters.token) {
            this.$store.dispatch(this.$actionTypes.user.GET_PROFILE)
        }
    },
    methods: {
        redirectTo (url) {
            this.$router.push(url)
        }
    }
}
</script>
<style scoped lang="scss">
    .app-name {
        font-size: 23px;
        font-weight: bold;
        color: #fff;
        margin-left: 10px;
        width: 250px;

        &.mobile {
            margin-top: 0;
        }
    }

    .logo {
        width: 110px;
        height: 40px;
        cursor: pointer;
    }

    .app-header {
        background: transparent linear-gradient(90deg, #0052CC 0%, #317CED 85%, #0052CC 100%) 0 0 no-repeat padding-box;
    }
</style>
